/* Maison Sahari v3 (01-10) : accessibilite (C1, C2, C11) et synchronisation des coloris (C4). */
(function () {
  'use strict';
  var en = (document.documentElement.lang || '').indexOf('en') === 0;
  function fixA11y(scope) {
    scope.querySelectorAll('button[aria-selected]').forEach(function (b) {
      var on = b.getAttribute('aria-selected') === 'true';
      b.removeAttribute('aria-selected');
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    scope.querySelectorAll('.slideshow-controls__thumbnails').forEach(function (g) {
      if (!g.getAttribute('role')) g.setAttribute('role', 'group');
      if (!g.getAttribute('aria-label')) g.setAttribute('aria-label', en ? 'Product photos' : 'Photos du produit');
    });
    scope.querySelectorAll('.product-recommendations__skeleton-item[aria-label]').forEach(function (s) {
      s.removeAttribute('aria-label');
      s.setAttribute('aria-hidden', 'true');
    });
    scope.querySelectorAll('slideshow-slides').forEach(function (s) {
      if (!s.hasAttribute('role')) s.setAttribute('role', 'group');
      if (!s.getAttribute('aria-label')) s.setAttribute('aria-label', en ? 'Product photos' : 'Photos du produit');
      if (s.getAttribute('tabindex') === '-1') s.setAttribute('tabindex', '0');
    });
    scope.querySelectorAll('li.menu-list__list-item[role="presentation"]').forEach(function (li) { li.removeAttribute('role'); });
    scope.querySelectorAll('header-menu button[role="listitem"], overflow-list button[role="listitem"]').forEach(function (b) { b.removeAttribute('role'); });
    /* C1 : nom accessible du bouton de la barre collante */
    scope.querySelectorAll('.sticky-add-to-cart__button:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', en ? 'Add to cart' : 'Ajouter au panier');
    });
    /* C11 : navigations du pied de page nommees d'apres leur titre */
    scope.querySelectorAll('nav.ms-foot__col:not([aria-label])').forEach(function (n) {
      var t = n.querySelector('.ms-foot__col-title');
      if (t && t.textContent.trim()) n.setAttribute('aria-label', t.textContent.trim());
    });
  }
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; fixA11y(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver(schedule).observe(document.body || document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected'] });

  /* Echap ferme le sous-menu et garde le focus sur le declencheur */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var t = document.querySelector('header-menu [aria-expanded="true"]');
    if (!t) return;
    t.setAttribute('aria-expanded', 'false');
    document.documentElement.setAttribute('data-ms-esc', '');
    t.focus();
  });
  document.addEventListener('pointermove', function () { document.documentElement.removeAttribute('data-ms-esc'); }, { passive: true });
})();

(function () {
  'use strict';
  /* C4 : l'URL, le champ id et le coloris coche designent le meme variant */
  function idInput() { return document.querySelector('form[action*="/cart/add"] input[name="id"]'); }
  function syncUrl() {
    var f = idInput();
    if (!f || !f.value) return;
    var u = new URL(location.href);
    if (u.searchParams.get('variant') !== f.value) {
      u.searchParams.set('variant', f.value);
      try { history.replaceState(history.state, '', u); } catch (e) {}
    }
  }
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('variant-picker')) return;
    setTimeout(syncUrl, 600);
  });
  function resync() {
    var checked = document.querySelectorAll('variant-picker input[type="radio"]:checked');
    if (!checked.length) return;
    checked.forEach(function (i) { i.setAttribute('autocomplete', 'off'); });
    checked[checked.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(syncUrl, 800);
  }
  window.addEventListener('pageshow', function (e) {
    var nav = (performance.getEntriesByType('navigation')[0] || {}).type;
    if (e.persisted || nav === 'back_forward') setTimeout(resync, 300);
  });
  document.querySelectorAll('variant-picker input[type="radio"]').forEach(function (i) { i.setAttribute('autocomplete', 'off'); });
})();